import { useState, useEffect } from 'react';
import { getActiveEventCountByTeam } from '../db/supabase-operations';

export function useLiveEventCount(teamId: string | undefined): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!teamId) {
      setCount(0);
      return;
    }

    let cancelled = false;

    const poll = async () => {
      const n = await getActiveEventCountByTeam(teamId);
      if (!cancelled) setCount(n);
    };

    poll();
    const interval = setInterval(poll, 15_000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [teamId]);

  return count;
}
